// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"2bb179c9","396":"5c3526b2","453":"cd86623b","455":"f8cd49dd","977":"45fdf5a2"}[chunkId] + ".chunk.js";
};